<script setup>
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import FeatureSpotlight from 'dashboard/components-next/feature-spotlight/FeatureSpotlight.vue';
import Button from 'dashboard/components-next/button/Button.vue';

import faqsLight from 'assets/images/dashboard/pilot/faqs-light.svg';
import faqsDark from 'assets/images/dashboard/pilot/faqs-dark.svg';

const router = useRouter();
const { isOnChatwootCloud } = useAccount();

const goToConversations = () => {
  router.push({ name: 'home' });
};

// 假数据
const pendingFaqsList = [
  {
    id: 1,
    question: '如何重置密码？',
    answer:
      '您可以在登录页面点击"忘记密码"链接，输入注册邮箱后按照提示操作即可重置密码。',
    status: 'pending',
    created_at: Date.now() / 1000 - 3600,
  },
  {
    id: 2,
    question: '如何联系客服？',
    answer:
      '您可以通过网站右下角的在线客服图标，或者发送邮件至 support@example.com 联系我们。',
    status: 'pending',
    created_at: Date.now() / 1000 - 7200,
  },
  {
    id: 3,
    question: '支持哪些支付方式？',
    answer:
      '我们支持支付宝、微信支付、银行卡支付等多种支付方式，您可以根据需要选择。',
    status: 'pending',
    created_at: Date.now() / 1000 - 10800,
  },
];

const getStatusClass = status => {
  switch (status) {
    case 'pending':
      return 'bg-n-amber-1 dark:bg-n-amber-2 text-n-amber-10 dark:text-n-amber-9';
    case 'approved':
      return 'bg-n-green-1 dark:bg-n-green-2 text-n-green-10 dark:text-n-green-9';
    case 'rejected':
      return 'bg-n-red-1 dark:bg-n-red-2 text-n-red-10 dark:text-n-red-9';
    default:
      return 'bg-n-slate-1 dark:bg-n-slate-2 text-n-slate-10 dark:text-n-slate-9';
  }
};

const getStatusText = status => {
  switch (status) {
    case 'pending':
      return '待审核';
    case 'approved':
      return '已通过';
    case 'rejected':
      return '已拒绝';
    default:
      return status;
  }
};
</script>

<template>
  <FeatureSpotlight
    :title="$t('PILOT.PENDING_FAQS.FEATURE_SPOTLIGHT.TITLE')"
    :note="$t('PILOT.PENDING_FAQS.FEATURE_SPOTLIGHT.NOTE')"
    :fallback-thumbnail="faqsLight"
    :fallback-thumbnail-dark="faqsDark"
    class="mb-8"
    :hide-actions="!isOnChatwootCloud"
  />
  <EmptyStateLayout
    :title="$t('PILOT.PENDING_FAQS.EMPTY_STATE.TITLE')"
    :subtitle="$t('PILOT.PENDING_FAQS.EMPTY_STATE.SUBTITLE')"
  >
    <template #empty-state-item>
      <div class="space-y-3 px-4">
        <div
          v-for="item in pendingFaqsList"
          :key="item.id"
          class="p-4 border border-n-container rounded-xl bg-n-slate-white dark:bg-n-slate-900"
        >
          <div class="flex items-start justify-between gap-4">
            <div class="flex-1 min-w-0">
              <h4
                class="text-sm font-medium text-n-slate-12 dark:text-n-slate-1 mb-1"
              >
                {{ item.question }}
              </h4>
              <p
                class="text-sm text-n-slate-10 dark:text-n-slate-4 line-clamp-2 mb-2"
              >
                {{ item.answer }}
              </p>
              <div
                class="flex items-center gap-3 text-xs text-n-slate-9 dark:text-n-slate-5"
              >
                <span
                  class="inline-flex items-center px-2 py-0.5 rounded-full"
                  :class="getStatusClass(item.status)"
                >
                  {{ getStatusText(item.status) }}
                </span>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <span class="i-lucide-check h-4 w-4 text-n-slate-9" />
              <span class="i-lucide-x h-4 w-4 text-n-slate-9" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #actions>
      <Button
        :label="$t('PILOT.PENDING_FAQS.EMPTY_STATE.GO_TO_CONVERSATIONS')"
        icon="i-lucide-message-circle"
        @click="goToConversations"
      />
    </template>
  </EmptyStateLayout>
</template>
